import { useEffect, useMemo, useState } from "react";
import axios from "@helpers/axios/private.axios";

let cachedSlugs = null;
let cachedAtMs = 0;
const CACHE_TTL_MS = 5 * 60 * 1000;

export const useFuturesPairsSlugs = () => {
  const [slugs, setSlugs] = useState(() => cachedSlugs || []);
  const [loading, setLoading] = useState(() => !cachedSlugs);

  useEffect(() => {
    let mounted = true;

    const isCacheFresh = cachedSlugs && Date.now() - cachedAtMs < CACHE_TTL_MS;
    if (isCacheFresh) {
      setLoading(false);
      return () => {
        mounted = false;
      };
    }

    (async () => {
      try {
        setLoading(true);
        const resp = await axios.get("/futures-pairs");
        const pairs = resp?.data?.data || [];
        const nextSlugs = pairs
          .map((p) => String(p?.slug || "").trim().toUpperCase())
          .filter(Boolean);

        cachedSlugs = nextSlugs;
        cachedAtMs = Date.now();

        if (mounted) {
          setSlugs(nextSlugs);
        }
      } catch (e) {
        if (mounted) {
          setSlugs([]);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  const slugsSet = useMemo(() => new Set(slugs), [slugs]);

  return { slugs, slugsSet, loading };
};

